export default function hasItems(cart) {
  const items = cart?.items;
  return Boolean(items && items.length > 0);
}
